import { fork } from 'redux-saga/effects'
import * as editor from './editorSaga'
import * as projects from './projectsSaga'
import * as presentation from './presentationSaga'
import * as auth from './authSaga'
import * as locationSaga from './locationSaga'

export default function* rootSaga() {
  /*editor*/
  yield fork(editor.runFetchProjectHandler)
  yield fork(editor.runUpdateProjectStartedHandler)
  yield fork(editor.runResetProjectHandler)
  yield fork(editor.runUpdateEventImageHandler)
  yield fork(editor.runUpdateQuestionTypeHandler)
  yield fork(editor.runUpdateChoiceImageHandler)
  yield fork(editor.runDeleteChoiceImageHandler)
  yield fork(editor.runCreateQuestionHandler)
  yield fork(editor.runDeleteQuestionHandler)
  yield fork(editor.runChangeRankingHandler)
  yield fork(editor.runUpdateAllQuestionsHandler)
  yield fork(editor.runLogOutHandler)
  yield fork(editor.runGetIsFetchableRankingDataHandler)
  yield fork(editor.runGetRankingDataHandler)
  /*projects*/
  yield fork(projects.runFetchProjectHandler)
  /*presentation*/
  yield fork(presentation.runFetchProjectHandler)
  yield fork(presentation.runFetchRankingHandler)
  yield fork(presentation.runFetchAnswerCountHandler)
  yield fork(presentation.runUpdateAnswerChoiceHandler)
  /* auth */
  yield fork(auth.runPostSignupHandler)
  yield fork(auth.runPostLoginHandler)
  yield fork(auth.runPostPaymentHandler)
  yield fork(auth.runResetPasswordHandler)
  yield fork(auth.runWithdrawHandler)
  /* location */
  yield fork(locationSaga.runLocationChangeHandler)
}
